<template>
  <div class="content">
    <div ref="tablePanel" class="fullheight">
      <div class="top_search">
        <el-row style="height: 100%; width: 100%">
          <el-col :span="7" class="col_style" :offset="10">
            <p>开票日期：</p>
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="dateRangeVal"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="loadData(true)"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6" class="col_style" :offset="1">
            <el-input v-model="code" placeholder="请输入发票申请单号,客户名称搜索" suffix-icon="el-icon-search" @keyup.enter.native="loadData(true)">
              <!-- <el-button slot="append" type="primary" @click="loadData(true)"
                >搜索</el-button
              > -->
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="searchPart">
        <el-tabs v-model="activeName" @tab-click="handleTab">
          <el-tab-pane v-for="item in tabList" :key="item.index" :label="item.label" :name="item.name"></el-tab-pane>
        </el-tabs>
      </div>
      <el-table
        ref="ecoTable"
        :data="tableData"
        :style="{
          height: `${tableMaxHeight}` + 'px'
        }"
        :max-height="tableMaxHeight"
        border
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="audit_no" label="发票申请单号" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="showDialog(scope.row.id)">{{ scope.row.audit_no }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="apply_date" label="申请日期" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="customer_name" label="客户名称" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="apply_amount" label="申请发票金额" :show-overflow-tooltip="true" :formatter="num_formatter"> </el-table-column>
        <el-table-column prop="invoice_status" label="开票状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span style="color: red" v-if="scope.row.invoice_status == 1"> 待开票 </span>
            <span style="color: green" v-if="scope.row.invoice_status == 2"> 已开票 </span>
          </template>
        </el-table-column>
        <el-table-column prop="invoice_amount" label="实际开票金额" :formatter="num_formatter" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="audit_date" label="开票日期" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="handleClick(scope.row, 0)" v-if="!isTenant && scope.row.invoice_status == 1">开票并录入</el-link>
            <el-link type="primary" :underline="false" @click="handleClick(scope.row, 1)" class="marginRight16" v-if="isTenant && scope.row.invoice_status == 1"
              >编辑</el-link
            >
            <el-link type="primary" :underline="false" @click="handleClick(scope.row, 2)" v-if="!isTenant && scope.row.invoice_status == 2">编辑</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 详情页面 -->
      <invoice-detail :detailId="detailId" :show="showDetail" @closeDetailDialog="closeDetailDialog" />
      <!-- 开票编辑-企业 -->
      <invoice-record-detail-order :show="showInvoice" :id="insertId" @closeDetailDialog="closeInvoice" />
      <!-- 开票并录入页面 -->
      <invoice-record-detail-edit :detailId="insertId" :show="showDetailEdit" @closeDetailDialog="closeDetailDialogEdit" />
    </div>
  </div>
</template>

<script>
import InvoiceRecordDetailOrder from './invoiceRecord/invoiceRecordDetailOrder.vue'
import utils from '@/utils.js'
import InvoiceRecordDetailEdit from './invoiceRecord/invoiceRecordDetailEdit.vue'
const invoiceDetail = () => import('@/views/form/invoiceRecord/invoiceRecordDetail.vue')

export default {
  components: {
    invoiceDetail,
    InvoiceRecordDetailOrder,
    InvoiceRecordDetailEdit
  },
  data() {
    return {
      tableMaxHeight: document.body.clientHeight - 200,
      showInvoice: false,
      editId: '',
      isTenant: false,
      activeName: '0',
      tabList: [
        {
          label: '全部',
          name: '0'
        },
        {
          label: '待开票',
          name: '1'
        },
        {
          label: '已开票',
          name: '2'
        }
      ],
      code: '',
      dateRangeVal: [],
      detailId: '',
      showDetail: false,
      insertId: '',
      showDetailEdit: false,
      tableData: [],
      searchDateRange: '',
      total: 0,
      pageSize: 20,
      currentPage: 1
    }
  },
  watch: {
    tableData: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.ecoTable.doLayout()
          })
        }
      }
    }
  },
  mounted() {
    this.isTenant = sessionStorage.getItem('tenantId') == -1 || !sessionStorage.getItem('tenantId') ? false : true
    this.loadData()
    this.calcTableHeight()
  },
  methods: {
    //关闭对话框
    closeInvoice(val) {
      this.showInvoice = false
      this.$refs.ecoTable.clearSelection()
      if (val) {
        this.currentPage = 1
        this.loadData()
      }
    },
    //表头样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const obj = {
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
      return obj
    },
    //列表样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (str.indexOf('金额') > -1 || str.indexOf('收款') > -1) {
          return 'text-align:right'
        } else {
          return 'text-align:left'
        }
      } else {
        return 'text-align:center'
      }
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 220
      }, delay || 0)
    },
    // 关闭详情对话框
    closeDetailDialog() {
      this.showDetail = false
    },
    // 关闭开票并录入对话框
    closeDetailDialogEdit(data) {
      this.showDetailEdit = false
      if (data) {
        this.currentPage = 1
        this.loadData()
      }
    },
    // 获取tab数字
    getNum(param) {
      this.$http.post('${third}/costcenter/third_invoice_apply/queryCount', param).then(
        (resp) => {
          if (resp.data) {
            this.tabList = [
              {
                label: '全部' + '(' + resp.data.total_count + ')',
                name: '0'
              },
              {
                label: '待开票' + '(' + resp.data.wait_invoice_count + ')',
                name: '1'
              },
              {
                label: '已开票' + '(' + resp.data.already_invoice_count + ')',
                name: '2'
              }
            ]
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // tab切换
    handleTab(tab, event) {
      this.activeName = tab.index
      this.currentPage = 1
      this.loadData()
    },
    // 获取列表数据
    loadData(isSearch) {
      if (isSearch) this.currentPage = 1
      const params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: this.total
        },
        querys: []
      }
      if (this.dateRangeVal && this.dateRangeVal.length) {
        params.querys.push({
          group: 'advance',
          operation: 'BETWEEN',
          property: 'audit_date',
          relation: 'AND',
          value: this.dateRangeVal
        })
      }
      if (this.code) {
        params.querys.push(
          {
            group: 'quick',
            operation: 'LIKE',
            property: 'audit_no',
            relation: 'OR',
            value: this.code
          },
          {
            group: 'quick',
            operation: 'LIKE',
            property: 'customer_name',
            relation: 'OR',
            value: this.code
          }
        )
      }
      this.getNum(JSON.parse(JSON.stringify(params)))
      switch (this.activeName) {
        case '1':
          params.querys.push({
            group: 'advance',
            operation: 'EQUAL',
            property: 'invoice_status',
            relation: 'AND',
            value: 1
          })
          break
        case '2':
          params.querys.push({
            group: 'advance',
            operation: 'EQUAL',
            property: 'invoice_status',
            relation: 'AND',
            value: 2
          })
          break
      }

      this.$http.post('${third}/costcenter/third_invoice_apply/query', params).then(
        (resp) => {
          let response = resp.data
          if (response) {
            this.tableData = response.rows
            this.currentPage = response.page
            this.pageSize = response.pageSize
            this.total = response.total
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // 开票并录入
    handleClick(item, type) {
      this.insertId = item.id

      switch (type) {
        case 0:
          this.showDetailEdit = true
          break
        case 1:
          this.showInvoice = true
          break
        case 2:
          this.showDetailEdit = true
          break
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 千分位格式化
    num_formatter(row, column, cellValue) {
      if (cellValue || cellValue == 0) {
        return utils.dataTransform(String(cellValue))
      }
    },
    // 详情页面弹出
    showDialog(id) {
      this.detailId = id
      this.showDetail = true
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.dialog-header-title span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}
.content {
  height: calc(100% - 20px);
  position: relative;
}
.tablePart {
  width: 100%;
  height: calc(100% - 65px - 32px - 23px - 20px - 65px);
}
.center {
  text-align: right;
  margin-top: 13px;
}
.top_search {
  height: 45px;
  width: 100%;
  position: absolute;
  top: 0px;
  right: 20px;
  z-index: 2;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
  p {
    flex-shrink: 0;
  }
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
</style>
